<template>
<page :title="i18n.wallet" :showBack="false">
  <div class="title">{{i18n.all_card}}</div>
  <div v-for="item in list" :key="item.pid">
    <card-item :item="item" @delete="deleteCard" :canDelte="true"></card-item>
  </div>
  <div class="add-btn" @click="addCard">{{i18n.add}}</div>
</page>
</template>

<script>
import { CARD_LIST, REMOVE_CARD, ADD_CARD_EVERYPAY } from '../../apis/payment'
import CardItem from './components/CardItem.vue'
export default {
  name: 'BankCard',
  components: { CardItem },
  computed: {
    i18n () {
      return this.$t('bankcard')
    },
    i18nMsg () {
      return this.$t('msg')
    },
    i18nConfirm () {
      return this.$t('confirm')
    }
  },
  data () {
    return {
      list: []
    }
  },
  created () {
    this.$loading(false)
    this.getCardList()
  },
  methods: {
    getCardList () {
      this.$loading(true)
      this.$get(CARD_LIST,
        {},
        resp => {
          this.$loading(false)
          this.list = resp.data
        },
        error => {
          this.$loading(false)
          console.log(error)
        }
      )
    },
    addCard () {
      this.$loading(true)
      this.$get(ADD_CARD_EVERYPAY,
        {},
        resp => {
          this.$loading(false)
          if (resp.code === 0) {
            console.log(resp)
            const data = resp.data || {}
            location.href = data.payment_link
            /* const data = resp.data || {}
            const form = document.createElement('form')
            form.method = 'post'
            form.action = 'https://testmpi.3dsecure.az/token/cgi_link'
            Object.keys(data).forEach(key => {
              const input = document.createElement('input')
              input.type = 'hidden'
              input.name = key
              input.value = data[key]
              form.appendChild(input)
            })
            document.body.appendChild(form)
            form.submit()
            document.body.removeChild(form) */
          }
        },
        error => {
          this.$loading(false)
          console.log(error)
          this.$confirm({
            title: this.i18nMsg.confirm,
            content: error,
            confirmText: this.i18nConfirm.msg_fail_confirm,
            showCancel: false
          }).then(() => {}).catch(() => {})
        })
    },
    deleteCard (id) {
      this.$confirm({
        title: this.i18nMsg.title,
        content: this.i18n.confirm_del_card,
        confirmText: this.i18nMsg.confirm,
        cancelText: this.i18nMsg.cancel
      }).then(() => {
        this.$loading(true)
        this.$post(`${REMOVE_CARD}/${id}`, {},
          resp => {
            this.$loading(false)
            console.log(resp)
            this.getCardList()
          },
          error => {
            this.$loading(false)
            console.log(error)
          })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  font-size: 35px;
  padding: 20px 55px 20px;
  text-align: left;
}
.add-btn {
  position: fixed;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  height: 80px;
  line-height: 80px;
  border-radius: 8px;
  color: #fff;
  background-color: #3ca2fc;
  text-align: center;
  font-size: 35px;
  font-weight: bold;
  box-shadow: 1px 1px 10px #555;
}
</style>
